<template>
  <div id="app">
    <SiteNav v-if="showNav" :active="activeKey">
      <!-- Global actions on every non-bracket page (the bracket fills this slot
           itself with its full set). Styled by Luxstadio's non-scoped .snav-act
           rules, which are always loaded (Luxstadio is statically imported). -->
      <template #actions>
        <NavLogin :username="myUsername" />
        <span class="snav-act">
          <a class="generator-button" href="?build&random" aria-label="Random unit generator">🎲</a>
          <span class="act-tip">Roll a random FFTBG unit in the Builder — force or ban classes and skills, then tweak anything.</span>
        </span>
      </template>
    </SiteNav>
    <component :is="view" />
    <DataStamp :chat="isChat" />
  </div>
</template>

<script>
// Router-less page switch (see src/routes.js for the section registry). The
// active section is resolved once from the ?query at boot — switching sections
// is a full page load, which suits a static-hosted, code-split content site.
// TODO: a real history-API router would give clean /paths + no-reload section
// transitions, but the gains are mostly cosmetic here and it'd break 6 years of
// shareable ?query URLs (needs redirects). Parked — see routes.js. The pain it
// would solve (adding a page) is handled by the registry: one entry, no edits
// here or in SiteNav.
import { defineAsyncComponent } from 'vue';
import Luxstadio from './Luxstadio.vue';
import SiteNav from './components/SiteNav.vue';
import DataStamp from './components/DataStamp.vue';
import NavLogin from './components/NavLogin.vue';
import { SECTIONS, resolveSection } from './routes.js';
import { loadPrefs } from './lib/userPrefs.js';

// Bracket (the default) stays statically imported in the entry bundle; every
// other section is code-split so its view + page-only JSON load on demand.
const components = { SiteNav, Luxstadio, DataStamp, NavLogin };
for (const s of SECTIONS) if (s.loader) components[s.key] = defineAsyncComponent(s.loader);

export default {
  name: 'app',
  components,
  data() { return { section: resolveSection(), myUsername: (loadPrefs().myUsername || '').trim() }; },
  computed: {
    view() { return this.section.key === 'bracket' ? 'Luxstadio' : this.section.key; },
    showNav() { return this.section.key !== 'bracket'; },   // Luxstadio renders its own SiteNav (with the bracket action icons)
    activeKey() { return this.section.activeAs === undefined ? this.section.key : this.section.activeAs; },
    isChat() { return this.activeKey === 'chat'; },   // the Chat section: its footer also says when chat was rebuilt
  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
